import { render, staticRenderFns } from "./TS06.vue?vue&type=template&id=d272e596&scoped=true&"
import script from "./TS06.vue?vue&type=script&lang=js&"
export * from "./TS06.vue?vue&type=script&lang=js&"
import style0 from "./TS06.vue?vue&type=style&index=0&id=d272e596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d272e596",
  null
  
)

export default component.exports